import {useMutation, useQueryClient} from '@tanstack/react-query';
import Api from '../api/Api';
import {MUTATION_KEYS, QUERY_KEYS} from './queryKeys';

export default function useDeleteShoppingItemMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MUTATION_KEYS.cart.deleteShoppingItem],
    mutationFn: async (orderId: string) => {
      return await Api.shopping.DeleteShoppingItem(orderId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.cart.getShoppingCart] });
    },
  });
}
